export default {
  components: {
    fitWorkflowProgress: {
      next: '下一步',
      previous: '上一步'
    },

    FITFileUpload: {
      select: '选择文件',
      upload: '上传文件',
      fileName: '文件名',
      size: '文件容量',
      publicDocument: '公开文件',
      isPublic: '公开',
      documentTag: '标签',
      remarks: '备注',
      isDownloadable: '可供下载',
      remove: '删除',
      dropFileMsg: '拉动文件至此用于上传',
      uploadRemindMsg: '请务必于选择文件完成后点选“上传文件”',
      successMsg: '您的文件已成功上传。',
      errorMsg: '您的文件上传失败，请稍候再试'
    },
    FITOutstandingRequirement: {
      general: {
        ID: '编号',
        type: '种类',
        clientID: '客户编号',
        submitBtn: '提交',
        lastUpdate: '最后更新',
        replys: '回覆',
        createAgent: '创建顾问',
        createTime: '创建日期',
        updateTime: '更新日期',
        subject: '主题',
        status: '状态',
        caseID: '档案编号',
        caseActionPrefix: '确认',
        caseActionPostfix: '此附加要求',
        fileDownloadErrorMsg: ' 请允许浏览器“弹出窗口”用于文件下载',
      },
      createCase: {
        title: '创建档案',
        header: '创建附加要求',
        description: '内容',
        confirmMsg: '确认创建此附加要求？',
        errorMsg: '创建附加要求失败，请稍候再试。',
      },
      caseHistory: {
        title: '档案列表',
        header: '附加要求列表',
        createBtn: '创建档案',
        noDataMsg: '无附加要求记录',
      },
      caseDetail: {
        title: '档案详情',
        header: '附加要求详情',
        errorMsg: '回覆失败，请稍候再试',
        information: '详情',
        correspondence: '回应',
        documents: '文档列表',
        comfirmReplyMsg: '确认提交此回覆？',
        replyBtn: '回复',
        closeBtn: '关闭',
        acceptBtn: '批准',
        rejectBtn: '拒绝',



      },
    },

  }
}



// WEBPACK FOOTER //
// ./src/components/langs/zh_cn/index.js